import React, { ReactNode } from "react";
import { KeyHandoverProvider } from "../context/KeyHandoverContext";
import { KeyHandoverServiceProvider } from "../context/KeyHandoverServiceContext";

interface KeyHandoverContentWrapperProps {
  /** Content to render within providers */
  children: ReactNode;
}

/**
 * Wraps content with required Key Handover context providers.
 * 
 * @remarks
 * Provides consistent provider setup for all Key Handover pages:
 * - KeyHandoverProvider (locations, filtered by "keys")
 * - KeyHandoverServiceProvider (services)
 * 
 * @example
 * ```tsx
 * <KeyHandoverContentWrapper>
 *   <MyPageContent />
 * </KeyHandoverContentWrapper>
 * ```
 */
export const KeyHandoverContentWrapper: React.FC<KeyHandoverContentWrapperProps> = ({
  children,
}) => {
  return (
    <KeyHandoverProvider serviceFilter="keys">
      <KeyHandoverServiceProvider typesFilter="keys">
        {children}
      </KeyHandoverServiceProvider>
    </KeyHandoverProvider>
  );
};
